import React, { useState, useEffect } from "react";
import HangerTable from "./HangerTable";
import SpacingTable from "./SpacingTable";
import RiserClampsTable from "./RiserClampsTable";
import UnistrutTable from "./UnistrutTable";

function HVAC({
  allData = { hangers: [], spacing: [], riserClamps: [], unistrut: [] },
  onSubTabChange,
  activeSubTab,
  onEditHanger,
  onDeleteHanger,
  onEditSpacing,
  onDeleteSpacing,
  onEditRiserClamp,
  onDeleteRiserClamp,
  onEditUnistrut,
  onDeleteUnistrut,
}) {
  const renderTabContent = () => {
    switch (activeSubTab) {
      case "hangers":
        return (
          <HangerTable
            hangersData={allData.hangers}
            onEdit={onEditHanger}
            onDelete={onDeleteHanger}
          />
        );
      case "spacing":
        return (
          <SpacingTable
            spacingData={allData.spacing}
            onEdit={onEditSpacing}
            onDelete={onDeleteSpacing}
          />
        );
      case "riser-clamps":
        return (
          <RiserClampsTable
            riserClampsData={allData.riserClamps}
            onEdit={onEditRiserClamp}
            onDelete={onDeleteRiserClamp}
          />
        );
      case "unistrut":
        return (
          <UnistrutTable
            unistrutData={allData.unistrut}
            onEdit={onEditUnistrut}
            onDelete={onDeleteUnistrut}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div className="w-full">
      {/* Sub-tab Navigation */}
      <div className="flex justify-center items-center gap-2 mb-6">
        <button
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            activeSubTab === "hangers"
              ? "bg-indigo-100 text-indigo-700 border-2 border-indigo-200"
              : "bg-gray-100 text-gray-600 hover:bg-indigo-50 hover:text-indigo-600"
          }`}
          onClick={() => onSubTabChange("hangers")}
        >
          Hangers
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            activeSubTab === "spacing"
              ? "bg-indigo-100 text-indigo-700 border-2 border-indigo-200"
              : "bg-gray-100 text-gray-600 hover:bg-indigo-50 hover:text-indigo-600"
          }`}
          onClick={() => onSubTabChange("spacing")}
        >
          Spacing
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            activeSubTab === "riser-clamps"
              ? "bg-indigo-100 text-indigo-700 border-2 border-indigo-200"
              : "bg-gray-100 text-gray-600 hover:bg-indigo-50 hover:text-indigo-600"
          }`}
          onClick={() => onSubTabChange("riser-clamps")}
        >
          Riser Clamps
        </button>
        <button
          className={`px-4 py-2 text-sm font-medium rounded-lg transition-all duration-200 ${
            activeSubTab === "unistrut"
              ? "bg-indigo-100 text-indigo-700 border-2 border-indigo-200"
              : "bg-gray-100 text-gray-600 hover:bg-indigo-50 hover:text-indigo-600"
          }`}
          onClick={() => onSubTabChange("unistrut")}
        >
          Unistrut
        </button>
      </div>

      {/* Tab Content */}
      <div className="mt-6">{renderTabContent()}</div>
    </div>
  );
}

export default HVAC;
